import React, { useState, useEffect } from "react";
import TauriCalendar from "./TauriCalendar/TauriCalendar";
import TauriImage from "../../TauriImage/TauriImage";
import DatePicker from "react-datepicker";
import { useParams } from "react-router-dom";
import ToggleSwitch from "../../ToggleSwitch/ToggleSwitch";
import "./PlanningView.css";
import { getAll } from "../../../localDB";

const PlanningView = ({selectedDate, setSelectedDate}) => {
  const { id } = useParams();

  const [details, setDetails] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [toggleSwitch, setToggleSwitch] = useState(true);

  const handlePrevMonth = () => {
    setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setSelectedDate(new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 1));
  };

  const handleDateChange = (date) => {
    if (!date) return;

    date.setHours(0, 0, 0, 0); // Ensure correct day is maintained
    setSelectedDate(date);
  };

  const fetchData = async () => {
    try {
      const planning = await getAll("planning");
      const holidayData = await getAll("holiday");

      const itemCalendarDetails = planning.map(plan => {
        const customerCount = plan.details.length;

        // Count distinct file attachments across all details
        const fileCount = plan.details.reduce((total, detail) => {
          return total + (detail.file ? detail.file.length : 0);
        }, 0);

        return {
          date: plan.plan_date,
          item: [
            {
              icon: { name: "/Images/solar--users-group-rounded-bold.svg", color: "#068DE2" },
              value: customerCount,
            },
            {
              icon: { name: "/Images/solar--buildings-outline.svg", color: "#068DE2" },
              value: customerCount,
            }
          ]
        };
      });

      setDetails(itemCalendarDetails);
      setHolidays(holidayData)

    } catch (error) {
      console.log(error);
    } finally {

    }
  }

  useEffect(() => {
    fetchData();
  }, [id]);

  const handleAdd = (date) => {
    let data = JSON.parse(localStorage.getItem('ofd_plm_sb_item')) || [];

    data = data.map(item => {
      if (item.id === Number(id)) {
        return { ...item, frequency: item.frequency + 1 };
      }
      return item;
    });

    setDetails(prevItems => prevItems.map(item => {
      if (item.date === date) {
        return {
          ...item,
          item: item.item ? item.item.map((i, index) => ({
            ...i,
            value: index === 0 ? i.value + 1 : (index === 1 ? i.value + 1 : i.value)
          })) : []
        };
      }
      return item;
    }));
  }

  const handleClick = (date) => {
    const selected = new Date(date);
    setSelectedDate(selected);
  }

  return (
    <div className="tauri-planning-view">
      <div className="date-section d-flex align-items-center justify-content-between">
        <TauriImage localImage={"/Images/arrow-left.svg"} className={"btn-arrowleft"} alt="btn" onClick={handlePrevMonth} />
        <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          dateFormat="MMMM yyyy" // Show Month & Year only
          showMonthYearPicker // Enables Month-Year selection
          customInput={
            <div className="datepicker-input">
              <span className="datepicker-text">
                {selectedDate.toLocaleDateString("en-US", {
                  month: "long",
                  year: "numeric",
                })}
              </span>
              <TauriImage localImage="/Images/arrow-down.svg" alt="arrow-down" className="dt-arrowdown" />
            </div>
          }
        />
        <TauriImage localImage={"/Images/arrow-right.svg"} className={"btn-arrowright"} alt="btn" onClick={handleNextMonth} />
      </div>
      <TauriCalendar
        date={selectedDate}
        items={details}
        holidays={holidays}
        currentDate={selectedDate}
        handleAdd={handleAdd}
        toggle={toggleSwitch}
        handleClick={handleClick}
      />

      <div className="planning-view-footer">
        <ToggleSwitch toggle={toggleSwitch} handleToggle={setToggleSwitch} />
      </div>
    </div >
  );
};

export default PlanningView;
